// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Businesses\DataProviders\BusinessField
// Generated on: <normalized>

export enum BusinessField {
  DB_TABLE = 'businesses',
  DB_IDENTIFIER = 'businessGUID',
  NAME = 'name',
  NICK_NAME = 'nickName',
  PARENT_COMPANY_NAME = 'parentCompanyName',
  ABN = 'ABN',
  ACN = 'ACN',
  SLAVE_DATA = 'slaveData',
  LOGO_FILE_DATA = 'logoFileData',
  BANK_ACCOUNT_DATA = 'bankAccountData',
  BANK_ACCOUNT_GUID = 'bankAccountGUID',
  PAYPAL_GUID = 'paypalGUID',
  STRIPE_GUID = 'stripeAccountGUID',
}

export const BusinessFieldGetEncryptionFields = [] as const;

export const BusinessFieldCases = ["businesses", "businessGUID", "name", "nickName", "parentCompanyName", "ABN", "ACN", "slaveData", "logoFileData", "bankAccountData", "bankAccountGUID", "paypalGUID", "stripeAccountGUID"] as const;
